import React, { ComponentProps, useMemo } from "react";
import { StyleSheet, View } from "react-native";
import { useTheme } from "../hooks/use-theme";
import { IconName } from "./Icon";
import IconButton from "./IconButton";
import Text from "./Text";
import HeaderActions from "./HeaderActions";

/**
 * This is a TEMPLATE to create new react functional components
 * copy this content and change it at your convenience
 */
type StackHeaderProps = {
    title: string;
    tintColor?: string; // Used to force a specific color for texts and icons
    leftIcon?: IconName;
    onLeftPress?: () => void;
    actions?: ComponentProps<typeof HeaderActions>["actions"];
};

const StackHeader: React.FC<StackHeaderProps> = ({
    title,
    tintColor,
    actions,
    onLeftPress,
    leftIcon,
}) => {
    const styles = useStyles();

    return (
        <View style={[styles.container]}>
            <Text
                numberOfLines={1}
                style={[
                    styles.title,
                    {
                        color: tintColor,
                        left: onLeftPress ? 45 : 0,
                        right: actions && actions.length ? 45 : 0,
                    },
                ]}
            >
                {title}
            </Text>

            {onLeftPress && (
                <IconButton
                    icon={leftIcon || "back"}
                    size={28}
                    iconColor={tintColor}
                    onPress={onLeftPress}
                    style={styles.leftButton}
                />
            )}
            <View style={{ flexGrow: 1 }} />
            {actions && actions.length > 0 && (
                <HeaderActions actions={actions} tintColor={tintColor} />
            )}
        </View>
    );
};

const useStyles = () => {
    const { colors, fonts, gridSize } = useTheme();
    return useMemo(
        () =>
            StyleSheet.create({
                container: {
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    position: "relative",
                    paddingHorizontal: gridSize / 2,
                    paddingVertical: 7,
                },
                title: {
                    ...fonts.bodyLarge,
                    color: colors.text,
                    flexGrow: 1,
                    textAlign: "center",
                    left: 0,
                    right: 0,
                    position: "absolute",
                },
                leftButton: {
                    flexGrow: 0,
                },
            }),
        [colors.text, fonts.bodyLarge, gridSize],
    );
};

export default StackHeader;
